import React from 'react'
import { ReturnScene } from '../../../shared/sso-workspace/return-card'

// The keypad's last screen once the other device is approved: the outcome
// card's "device" scene (return-card.js: this browser, the mark, the device
// that was signed in, with the short animation, still under reduced
// motion), then who it was. The dialog closes itself a moment later
// (use-device-code.js SUCCESS_CLOSE_MS). The dialog's own live region
// (accept-pin-login.js) announces it: a region mounted already filled is
// often not read.
export const SuccessView = ({ device }) => {
  const label = device && device.label
  return (
    <div className="sw-workspace ld-success" data-testid="device-success">
      <ReturnScene variant="device" deviceFamily={device && device.family} />
      <div className="ld-success__label">Device signed in</div>
      <div className="ld-success__sub">{label ? `${label} is finishing signing in.` : 'The other device is finishing signing in.'}</div>
    </div>
  )
}
